export default __webpack_public_path__ + "static/media/expire-frame.76030a32.svg";